export default "__VITE_ASSET__vWVEgKf1__"